import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Accelerator() {
  const rows = [{
    sit: 'Tu arancel',
    sin: 'El de la OS o menos',
    con: '30-50% sobre el mercado'
  }, {
    sit: 'Cobros',
    sin: 'Incómodos e irregulares',
    con: 'Sistema sin drama en 5 pasos'
  }, {
    sit: 'Captación',
    sin: 'Solo boca a boca',
    con: 'Boca a boca + Instagram + derivaciones médicas'
  }, {
    sit: 'Imagen profesional',
    sin: 'Sin sistema visible',
    con: 'Identidad profesional coherente'
  }, {
    sit: 'Escala',
    sin: 'Solo sesiones individuales',
    con: 'Talleres, grupos y productos digitales'
  }];
  const modules = [{
    icon: '🔍',
    title: 'Módulo 1 — Diagnóstico del Consultorio Estancado',
    desc: 'Autodiagnóstico de 10 puntos · Los 5 síntomas del consultorio estancado · La ilusión de la agenda llena · Calculadora de tiempo regalado'
  }, {
    icon: '🪤',
    title: 'Módulo 2 — La Trampa del Auto-Empleado',
    desc: 'Los 4 tipos de TO · Modelo de los 4 cuadrantes · Las 3 decisiones que separan al TO estancado del TO Élite'
  }, {
    icon: '💰',
    title: 'Módulo 3 — Ingeniería de Ingresos',
    desc: 'Calculadora de valor hora real · Matriz de precios por segmento · Script de aumento de honorarios · 5 servicios de alto valor · Mix de ingresos del TO Élite'
  }, {
    icon: '📱',
    title: 'Módulo 4 — Atracción de Pacientes Particulares',
    desc: 'Sistema de derivaciones médicas en 5 pasos · Carta para médicos · Pirámide de contenido · 5 publicaciones que más generan consultas · Embudo de conversión'
  }, {
    icon: '🎯',
    title: 'Módulo 5 — Marca Personal Técnica',
    desc: 'Mapa de especialidades TO Argentina 2026 · Posicionamiento · Propuesta de valor · Perfil de Instagram del TO Élite · Calendario de contenido · Google Mi Negocio'
  }, {
    icon: '🛡️',
    title: 'Módulo 6 — Blindaje de Tiempo',
    desc: 'Las 4 zonas de tiempo · Protocolo de blindaje de agenda · Comunicación con límites · WhatsApp Business con mensajes listos · Política de cancelaciones · Batching semanal'
  }, {
    icon: '🚀',
    title: 'Módulo 7 — Modelo de Escalamiento',
    desc: 'Talleres y grupos terapéuticos · Supervisión a colegas · Consultoría a instituciones educativas · Productos digitales · Cómo armar tu primer equipo · Mapa de ingresos en 3 etapas'
  }, {
    icon: '📊',
    title: 'Módulo 8 — Planificación Financiera Argentina 2026',
    desc: 'Tablero financiero mensual · Los 4 fondos del TO Élite · Estrategia anti-inflación · Cuándo dejar de ser monotributista'
  }, {
    icon: '📋',
    title: 'Módulo 9 — Plan de Acción de 90 Días',
    desc: 'Mes 1: Cimientos · Mes 2: Atracción · Mes 3: Escalamiento · Indicadores de éxito medibles por semana · Compromiso del TO Élite'
  }];
  return <section className="py-10 px-4 bg-dark-card/30 pt-[15px] pb-[15px]" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <div className="text-center mb-6" data-id="element-31">
          <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-32">
            🚀 ¿QUÉ AGREGA EL MÉTODO CONSULTORIO ÉLITE™?
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto" data-id="element-33">
            Para el TO que ya tiene las herramientas clínicas y ahora quiere
            construir una práctica que pague lo que merece.
          </p>
        </div>

        <div className="space-y-2 mb-8" data-id="element-34">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark-card border border-dark-border rounded-xl p-3 grid grid-cols-3 gap-2 items-center" data-id="element-35">
              <div className="font-bold text-white text-sm" data-id="element-36">{row.sit}</div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-37">
                <X className="w-3.5 h-3.5 text-red-400 flex-shrink-0" data-id="element-38" />
                <span className="text-gray-400" data-id="element-39">{row.sin}</span>
              </div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-40">
                <Check className="w-3.5 h-3.5 text-brand flex-shrink-0" data-id="element-41" />
                <span className="text-white font-medium" data-id="element-42">{row.con}</span>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-4" data-id="element-43">
          <h3 className="text-lg font-black text-white" data-id="element-44">
            ✅ INCLUYE 9 MÓDULOS:
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-45">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark border border-dark-border p-3 rounded-xl flex items-start space-x-2" data-id="element-46">
              <span className="text-lg" data-id="element-47">{mod.icon}</span>
              <div data-id="element-48">
                <h4 className="font-bold text-brand text-xs" data-id="element-49">{mod.title}</h4>
                <p className="text-gray-400 text-xs" data-id="element-50">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center" data-id="element-51">
          <p className="text-gray-300 italic text-sm max-w-xl mx-auto leading-relaxed" data-id="element-52">
            "Si los 6 Tomos te dieron las herramientas para ser un TO
            extraordinario clínicamente, el Método Consultorio Élite™ te da las
            herramientas para ser un TO extraordinario económicamente."
          </p>
        </motion.div>
      </div>
    </section>;
}